<template>
	<div>
		<div class="contribute">
			<div class="inner_view">
				<div>
					<span style="line-height: 32px">项目名称:</span>
					<el-input v-model="select.project_name" @clear="getApplyList" placeholder="请输入项目名称" :clearable="true"
						style="margin-left: 10px;width: 150px;margin-right: 20px;"></el-input>
				</div>
				<div>
					<span style="line-height: 32px;">小组名称:</span>
					<el-input v-model="select.group_name" @clear="getApplyList" placeholder="请输入小组名称" :clearable="true"
						style="margin-left: 10px;width: 150px;margin-right: 20px;"></el-input>
				</div>
				<div>
					<span style="line-height: 32px;">审核状态:</span>
					<el-select v-model="select.selectValue2" @clear="getApplyList" clearable placeholder="请选择"
						style="width: 150px;margin-left: 10px;margin-right: 20px;">
						<el-option v-for="(item, index) in select.options2" :key="index" :label="item" :value="index">
						</el-option>
					</el-select>
				</div>
				<div>
					<span style="line-height: 32px;">申报时间:</span>
					<el-date-picker v-model="select.selectValue3" @change="getApplyList" value-format="yyyy-MM-dd"
						style="width: 240px;margin-left: 10px;margin-right: 20px;" type="daterange"
						start-placeholder="开始日期" end-placeholder="结束日期">
					</el-date-picker>
				</div>

				<el-button type="primary" @click="searchData">
					查询
				</el-button>
			</div>
			<!-- 我要投稿 -->
			<!-- 批量同意推荐 -->
			<!--<el-button type="primary" @click="setRecommend" v-if="userLevel ==1">同意推荐</el-button>

			<el-button type="primary" @click="setRecommendApp"  v-if="loginRole">审核</el-button>-->
		</div>

		<div class="infoBody">
			<!-- 特俗样式表格 -->
			<normalTable v-loading="loading" :check="true" :tabList="tabList" :tableList="tableList"
				@copol-click="reciveClick" @checkbox="checkBox"></normalTable>
		</div>
		<div style="margin-top: 50px;" v-if="totalNum>10">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="totalNum" background>
			</el-pagination>
		</div>

		<!-- 弹窗 -->
		<scoreDialog ref="scoredialog" @chooseDetail="chooseDetail"></scoreDialog>

		<!-- 消息弹窗 -->
		<setTimeDialog ref="settimedialog"></setTimeDialog>

		<givePointDialog ref="givePoint"></givePointDialog>
		<appDialog ref="approve"></appDialog>
		<qcAppDialog ref="qcAppDialog"></qcAppDialog>

		<newAddDialog ref="download" @fresh="getApplyList"></newAddDialog>
	</div>
</template>

<script>
	import {
		getApplyList,
		givePoint,
		setRecommend,
	} from '../../api/moudles/management.js'
	import {
		getProjectType
	} from '../../api/moudles/application.js'
	import normalTable from '../../components/table/normalTable.vue'
	import scoreDialog from './components/scoreDialog.vue'
	import setTimeDialog from './components/setTimeDialog.vue'
	import givePointDialog from './components/givePoint.vue'
	import appDialog from './components/app.vue'
	import qcAppDialog from './components/qcApp.vue'
	import {
		deleteApply
	} from "../../api/moudles/management";
	import newAddDialog from './components/newAddDialog.vue'
	import {
		API_DOMAIN
	} from '../../api/api.js'
	export default {
		data() {
			return {
				dataList: [],
				project_type: [],
				select: {
					options1: [],
					options2: [],
					selectValue2: '',
					selectValue3: '',
					project_name:'',
					group_name:''
				},
				loading: true,
				loginRole: false,
				tabList: ['项目名称', '小组名称', '课题名称', '课题类型',  '申报人', '申报时间', '状态','成果等级', '动作'],
				tableList: [],
				tabCodeList: [],
				newUpCodeList: [],
				ids: [],
				// 分页
				currentPage: 1,
				pageSize: 10,
				totalNum: 0,
				userLevel: sessionStorage.getItem('userLevel')
			}
		},
		computed: {

		},
		components: {
			normalTable,
			scoreDialog,
			setTimeDialog,
			givePointDialog,
			appDialog,
			qcAppDialog,
			newAddDialog,
		},
		created() {
			// let loginRoleId = localStorage.getItem('loginRoleId')
			this.getApplyList()
			this.getProjecttype()
		},
		methods: {
			// 获取下拉选项
			async getProjecttype() {
				await getProjectType({
					success: res => {
						const appStatus = res.data.appStatus
						this.select.options2 = appStatus
					}
				})
			},
			searchData() {
				this.getApplyList()
			},
			// 分页
			handleSizeChange(val) {
				this.pageSize = val
				this.getApplyList()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getApplyList()
			},
			// 接口一：获取项目列表
			async getApplyList() {
				this.loading = true
				await getApplyList({
					data: {
						project_name: this.select.project_name,
						group_name: this.select.group_name,
						project_type: 11,
						app_status: this.select.selectValue2,
						apply_time: this.select.selectValue3,
						page: this.currentPage,
						limit: this.pageSize
					},
					success: (res) => {
						console.log('列表', res.data)
						this.totalNum = res.totalCount
						let dataList = res.data;
						this.dataList = res.data
						let newUpCode = []
						// code列表
						let upCode = []
						let upList = []
						// 类型列表
						let project_type = []

						dataList.forEach((item) => {
							let newlist = {}
							/*newlist['project_type_name'] = item.project.project_type_name*/
							newlist['project_name'] = item.project.project_name
							newlist['group_name'] = item.group_name
							newlist['achievement_name'] = item.achievement_name
							newlist['achievement_type'] = item.achievement_type
						/*	newlist['is_publish'] = item.is_publish*/
							newlist['created_by'] = item.created_by
							newlist['created_at'] = item.created_at
							newlist['statusText'] = item.statusText
							newlist['achieve_level'] = item.achieve_level

							if (item.status === '0' || item.status === '8') {
								newlist['soqcol'] = ['提交', '编辑', '删除']
							} else {
								if(item.achieve_level){
									newlist['soqcol'] = ['查看','成果下载']
								}else{
									newlist['soqcol'] = ['查看']
								}
							}

							upCode.push(item.id)
							newUpCode.push(item.project_app_num)
							project_type.push(item.project.project_type)
							upList.push(newlist)
						})
						this.tabCodeList = upCode
						this.tableList = upList
						this.newUpCodeList = newUpCode
						this.project_type = project_type
						this.loading = false
					}
				})
			},
			// 接口二：评分
			async givePoint() {
				await givePoint({
					data: {
						id: '',
						point: ''
					},
					success: res => {
						console.log(res)
					}
				})
			},
			submitSuccess(e) {
				console.log('e', e)
			},

			//审核推荐
			setRecommendApp(id) {

				const params = {
					ids: id
				}
				this.$refs['qcAppDialog'].showAdd(params)
				return

			},

			// 接口三：批量推荐
			async setRecommend() {
				if (!this.ids.length) {
					this.$message.error('请先选中数据')
					return
				}
				const params = {
					ids: this.ids
				}
				await setRecommend({
					data: {
						ids: this.ids
					},
					success: res => {
						if (res.code === 200) {
							this.$refs['settimedialog'].showAdd('success', res)
						} else {
							this.$refs['settimedialog'].showAdd('fail', res)
						}
						this.getApplyList()
					}
				})
			},
			// 接受子组件事件
			chooseDetail(e) {
				if (e.type) {
					this.$refs['settimedialog'].showAdd('success', e.res)
				} else {
					this.$refs['settimedialog'].showAdd('fail', e.res)
				}
				this.getApplyList()
			},
			// 复选框
			checkBox(e) {
				// console.log('接收到复选框', e)
				const newList = []
				e.forEach((item, index) => {
					if (item === true) {
						newList.push(this.tabCodeList[index])
					}
				})
				this.ids = newList
			},
			reciveClick(e) {
				const {
					list,
					key
				} = e
				if (list === '删除') {
					this.$confirm('此操作将删除该条申报记录, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						center: true
					}).then(() => {
						deleteApply({
							data: {
								project_app_num: this.dataList[key].project_app_num
							},
							success: res => {
								if (res.code !== 200) {
									this.$message({
										type: 'error',
										message: res.msg
									});
								} else {
									this.$message({
										type: 'success',
										message: '删除成功!'
									});
									this.getApplyList()
								}
							}
						})
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
				} else if (list === '编辑') {
					this.$router.push({
						name: 'QCteam',
						params: {
							type: 11,
							isAdd: 0,
							projectCode: this.newUpCodeList[key],
						}
					})
				} else if (list === '查看') {
					this.$router.push({
						name: 'newcontribute',
						params: {
							id: this.tabCodeList[key]
						}
					})

				} else if (list === '成果下载') {

					const url =
							`${API_DOMAIN}/proapi/down/download-achieve?project_app_num=${this.dataList[key].project_app_num}`
					window.open(url)

				} else if (list === '提交') {
					const params = {
						type: 'tips',
						project_app_num: this.dataList[key].project_app_num,
						status: '1',
					}
					this.$refs['download'].showAdd(params)
				}
			}
		}
	}
</script>

<style scoped>
	.contribute {
		display: flex;
		margin: 20px 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 40px;
	}

	.inner_view {
		line-height: 50px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		align-content: space-around;
		justify-content: flex-start;
	}

	/* 信息变更内容主体 */
	.infoBody {
		display: flex;
		flex-flow: column;
		justify-content: flex-start;
		width: 100%;
		height: 100%;
	}

	.contribute_head {
		display: flex;
		justify-content: flex-end;
		margin: 10px 0;
	}

	.contribute_head button {
		width: 85px;
		height: 30px;
		background: #158AED;
		border-radius: 2px;
		cursor: pointer;
		color: #ffffff;
	}
</style>
